import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Time from "../../Time/Time";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import Translator from "../../Translation/Translator";

export default function* contractExpiration(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONTRACT_EXPIRATION_REQUEST
    });

    const res = yield call(Http.put, `contract/${action.payload?.contractId}/expiration`, {
      expirationDate: Time.formatOrNull(action.payload?.expirationDate),
      text: action.payload?.text,
    });

    const contract: ContractInterface = ContractFactory.create(res.data);

    yield put({
      type: Constants.GLOBAL_CONTRACT_EXPIRATION_SUCCESS,
      payload: {
        contract: contract
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-contract-expiration-date-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CONTRACT_EXPIRATION_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchContractExpiration() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_EXPIRATION_START, contractExpiration);
}
